
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 447 492"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"d":"M85.4 463.9H33.1A21.1 21.1 0 0112 442.8v-201a21.1 21.1 0 0121.1-21.1h52.3a21.1 21.1 0 0121.1 21.1v201a21 21 0 01-21.1 21.1z","fill":"#343433","opacity":".18"}}),_c('path',{attrs:{"d":"M110.3 242.4H149a41 41 0 0030.1-13.2c7.8-8.6 18.8-22.7 33.2-46a39.82 39.82 0 006.1-18.3l3-36.5c2-24.5 33.1-34 48.3-14.6 1.8 2.3 3.6 4.8 5.4 7.4 30.3 44.2-8.7 124.1-8.7 124.1M342.6 429h1a25.48 25.48 0 0125.5 25.5h0a25.48 25.48 0 01-25.5 25.5h-78.5a151.05 151.05 0 01-111.5-49.1h-47.1","fill":"none","stroke":"#343433","stroke-linejoin":"round","stroke-width":"24"}}),_c('path',{attrs:{"d":"M335 429h32.6a30.34 30.34 0 0030.3-30.3h0a30.34 30.34 0 00-30.3-30.3H357M350.4 368.4H383a30.34 30.34 0 0030.3-30.3h0a30.34 30.34 0 00-30.3-30.3h-4.8","fill":"none","stroke":"#343433","stroke-linejoin":"round","stroke-width":"24"}}),_c('path',{attrs:{"d":"M369.1 307.8h35.6a30.34 30.34 0 0030.3-30.3h0a30.34 30.34 0 00-30.3-30.3H236.6","fill":"none","stroke":"#343433","stroke-linejoin":"round","stroke-width":"24"}}),_c('path',{attrs:{"d":"M85.4 463.9H33.1A21.1 21.1 0 0112 442.8v-201a21.1 21.1 0 0121.1-21.1h52.3a21.1 21.1 0 0121.1 21.1v201a21 21 0 01-21.1 21.1z","fill":"none","stroke":"#343433","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"24"}}),_c('path',{attrs:{"fill":"none","stroke":"#343433","stroke-linejoin":"round","stroke-width":"24","d":"M111.3 137.3H158M339.3 137.3h46.6M248.6 0v46.6M151.5 40.2l33 33M345.7 40.2l-33 33"}})])
          )
        }
      }
    